import JsonView from '@uiw/react-json-view'
import { FaX } from 'react-icons/fa6'

import { Button } from '../../../../components/Button'

interface ModalSeeLogChangesProps {
  onClose: () => void
  changes: object | null
  file?: string | null
}

export function ModalSeeLogChanges({ onClose, changes, file }: ModalSeeLogChangesProps) {
  function handleClose() {
    onClose()
  }

  return (
    <div
      className="fixed top-0 left-0 w-screen h-screen bg-black/65 flex items-center justify-center z-[10000]"
      onClick={handleClose}
    >
      <div
        className="flex flex-col bg-slate-100 relative rounded-md p-4 w-[80vw] max-h-[80dvh] md:w-96"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="flex justify-between mb-4">
          <h1 className="font-semibold text-2xl">
            Alterações
          </h1>
          <Button
            variant="ghost"
            size="icon"
            onClick={handleClose}
          >
            <FaX />
          </Button>
        </header>
        <div
          className="flex flex-col space-y-4 w-full max-h-[60dvh] overflow-y-auto bg-white rounded-md"
        >
          {changes && (
            <JsonView
              displayDataTypes={false}
              value={changes}
            />
          )}
        </div>
        {file && (
          <div className="flex items-center justify-center mx-auto overflow-hidden rounded-md w-fit">
            <img className="object-contain" src={`data:image/jpeg;base64,${file}`} />
          </div>
        )}
      </div>
    </div>
  )
}
